import React, { lazy, Suspense, useEffect, useState } from 'react';
import { StickyHeader } from './components/StickyHeader';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { MetaPixel } from './components/MetaPixel';
const DeferredLanding = lazy(() => import('./components/DeferredLanding').then(({
  DeferredLanding: Component
}) => ({
  default: Component
})));
export function App() {
  const [loadDeferredContent, setLoadDeferredContent] = useState(false);
  useEffect(() => {
    const timer = window.setTimeout(() => setLoadDeferredContent(true), 900);
    return () => window.clearTimeout(timer);
  }, []);
  return <div className="w-full bg-background font-sans text-foreground" data-id="element-0" data-mp="31ctbbg5tvg3d">
      <MetaPixel data-id="element-1" data-mp="2wj8fnurpiy7c" />
      <StickyHeader data-id="element-2" data-mp="2wip2ssgwz006" />
      <main data-id="element-3" data-mp="28ufqch5lbolp">
        <span id="hero-sentinel" aria-hidden="true" data-id="element-4" data-mp="28u5z6q8t7bef" />
        <Hero data-id="element-5" data-mp="28sl3uyeo7ofi" />
        <SocialProofBar data-id="element-6" data-mp="28sbe9bxjfjac" />
        {loadDeferredContent && <Suspense fallback={<div className="h-10 bg-background" aria-hidden="true" data-id="element-8" data-mp="23utcc5hxu4bu" />} data-id="element-7" data-mp="23u9t8lgjx9w8">
            <DeferredLanding data-id="element-9" data-mp="3ikr0s4yore8d" />
          </Suspense>}
      </main>
    </div>;
}